import { render, staticRenderFns } from "./ScriveAfterSignMappingsManagement.vue?vue&type=template&id=3fbfbdde&"
import script from "./ScriveAfterSignMappingsManagement.vue?vue&type=script&lang=ts&"
export * from "./ScriveAfterSignMappingsManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports